import React from 'react';

const Icons = () => {
    return (
        <div className="icons">
            <h1>Languages and Frameworks</h1>
            <i className="devicon-react-original-wordmark colored"></i>
            <i className="devicon-javascript-plain colored"></i>
            <i className="devicon-ruby-plain colored"></i>
            <i class="devicon-express-original"></i><br/><br/>
            <i className="devicon-rails-plain-wordmark colored"></i>
            <i className="devicon-redux-original colored"></i>
            <i className="devicon-postgresql-plain-wordmark colored"></i>
            <i className="devicon-git-plain-wordmark colored"></i><br/><br/>
            <i className="devicon-html5-plain-wordmark colored"></i>
            <i className="devicon-css3-plain-wordmark colored"></i>
            <i className="devicon-heroku-original-wordmark colored"></i>
            <i class="devicon-nodejs-plain"></i>
        </div>
    );
}

export default Icons;

